import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class ViewsService {
  // environmentcurr   = environment.name;
  // adminConfigBaseurl = environment.adminConfigurl;
  
  // constructor(private http: HttpClient) {
  //     if(this.environmentcurr == 'prod'){
  //       this.adminConfigBaseurl  = this.adminConfigBotBaseurl;
  //     }else{
  //       this.adminConfigBaseurl  = this.adminConfigBaseurl;
  //     }
  // }
  // private httpOptions = {
  //   headers: new HttpHeaders({
  //     "Content-Type": "application/json",
  //   }),
  // };
  // private httpOptionsnew = {
  //   headers: new HttpHeaders({
  //     "Content-Type": "application/json",
  //   }),
  // };

  // getLiqProviders(): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}liqproviders`,
  //     this.httpOptions
  //   );
  // }

  // getExchanges(): Observable<any> {
  //   return this.http.get(
  //     `${this.getcurrencyExchange}getExchangesWithCurrencies`,
  //     this.httpOptions
  //   );
  // }

  // getViews(): Observable<any> {
  //   return this.http.get(`${this.adminConfigBaseurl}views`, this.httpOptions);
  // }

  // postViews(data): Observable<any> {
  //   return this.http.post(
  //     `${this.adminConfigBaseurl}views`,
  //     this.httpOptions,
  //     data
  //   );
  // }

  // updateViews(id, data): Observable<any> {
  //   return this.http.put(
  //     `${this.adminConfigBaseurl}views/${id}`,
  //     this.httpOptions,
  //     data
  //   );
  // }

  // getLiquidityProviders(currencyPair): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}exchange/get_liquidity_provider/${currencyPair}`,
  //     this.httpOptions
  //   );
  // }

  // getAuctionConfiguration(userId): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}auction_configs/${userId}`,
  //     this.httpOptions
  //   );
  // }

  // saveAuctionConfiguration(config): Observable<any> {
  //   console.log(config);

  //   return this.http.post(this.adminConfigBaseurl+"auction_configs",config).pipe(map(resp=>resp));
  // }
  // updateAuctionConfiguration(config, userId): Observable<any> {
  //   return this.http.put(
  //     `${this.adminConfigBaseurl}auction_configs/${userId}`,
  //     config
  //   );
  // }


  // getAdminConfiguration(userId): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}price_configs/${userId}`,
  //     this.httpOptions
  //   );
  // }

  // saveAdminConfiguration(config): Observable<any> {
  //   console.log(config);

  //   return this.http.post(this.adminConfigBaseurl+"price_configs",config).pipe(map(resp=>resp));
  // }
  // updateAdminConfiguration(config, userId): Observable<any> {
  //   return this.http.put(
  //     `${this.adminConfigBaseurl}price_configs/${userId}`,
  //     config
  //   );
  // }

  // startService1(): Observable<any> {
  //   return this.http.post(
  //     `${this.adminConfigBaseurl}startBotByName/Bsdex`,
  //     this.httpOptionsnew
  //   );
  // }

  // startService(pairsource,targetexchange): Observable<any> {

  //   return this.http.post(
  //     `${this.adminConfigBaseurl}${targetexchange}/start/${pairsource}`,
  //     this.httpOptionsnew
  //   );
  // }
  // botStatusService(): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}isBsdexBotRunning`
  //   );
  // }
  // stopService(pairsource,targetexchange): Observable<any> {
  //   return this.http.post(
  //     `${this.adminConfigBaseurl}${targetexchange}/stop/${pairsource}`,
  //     this.httpOptionsnew
  //   );
  // }

  // startServiceById(data,id): Observable<any> {
  //   return this.http.post(
  //     `${this.adminConfigBaseurl}startBotLineItemById/${data}`,
  //     this.httpOptionsnew
  //   );
  // }

  // stopServiceById(data,id): Observable<any> {
  //   return this.http.post(
  //     `${this.adminConfigBaseurl}stopQuoteById/${data}`,
  //     this.httpOptionsnew
  //   );
  // }

  // placeAllAdminOrderes(): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}admin_configs/start/all`,
  //     this.httpOptions
  //   );
  // }

  // stopAllAdminOrderes(): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}admin_configs/stop/all`,
  //     this.httpOptions
  //   );
  // }
  // stopIndividualAdminOrder(action, name): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}admin_configs/${action}/${name}`,
  //     this.httpOptions
  //   );
  // }
  // placeIndividualAdminOrder(action, name): Observable<any> {
  //   return this.http.get(
  //     `${this.adminConfigBaseurl}admin_configs/${action}/${name}`,
  //     this.httpOptions
  //   );
  // }
}



// WEBPACK FOOTER //
// ./src/app/services/views.service.ts